/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor ({ width, height, geometry, offset })
  {
    this.width = width;
    this.height = height;
    this.geometry = geometry;
    this.offset = offset;
  }


  getCenterOffset (centerHex)
  {
    let { x, y } = this.geometry.getPointFromHex(centerHex);

    x = Math.round(this.width  / 2 - x);
    y = Math.round(this.height / 2 - y);

    return { x, y };
  }


  getBoardOffset (centerHex)
  {
    const center = this.getCenterOffset(centerHex);

    return { x: center.x + this.offset.x, y: center.y + this.offset.y };
  }


  getHexFromEvent (event, centerHex)
  {
    const { left, top } = event.currentTarget.getBoundingClientRect();

    const offset = this.getBoardOffset(centerHex);

    const x = event.clientX - offset.x - left;
    const y = event.clientY - offset.y - top;

    return this.geometry.getHexFromPoint({ x, y });
  }


};
